import { APP_HEADER } from "../common/constants";

export const stringsKey = "Shared";
export const englishStrings = {
	title: "Reach",
	appHeader: APP_HEADER,
	nrcLogoUrl: "NRC_logo_English.svg",
	ifrcLogoUrl: "IFRC_logo.png",
	confirmButtonText: "Confirm",
	deleteButtonText: "Delete",
	cancelButtonText: "Cancel",
	backToListBtnTooltip: "Back to Template List",
	closeButtonText: "Close",
	accessDeniedMessage:
		"You are not authorized to access this page. Please contact support for assistance.",
	requiredInput: "This is a required field",
};
